import Logger from 'common/services/Logger/Logger';

let _loading: boolean | null = null;
let _gtmScript: HTMLElement | null | undefined = null;

const createGtmScript = (
  w: Window,
  d: Document,
  s: string,
  l: string,
  i: string,
  ol: (event: any) => void,
  oe: (event: any) => void,
) => {
  //
  // @ts-ignore
  w[l] = w[l] || [];
  // @ts-ignore
  w[l].push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });
  const f = d.getElementsByTagName(s)[0];
  const j = d.createElement(s);
  const dl = l !== 'dataLayer' ? `&l=${l}` : '';
  if (j instanceof HTMLScriptElement) {
    j.async = true;
    j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;
  }
  j.onerror = (e: Event | string) => {
    oe(e);
  };
  j.onload = (e: Event) => {
    ol(e);
  };
  f.parentNode?.insertBefore(j, f);
  return j;
};

function initGtm(gtmId: string, dataLayerPreload: { userId?: string | null }) {
  const logger = new Logger('GTM');
  if (!gtmId) {
    console.error('initGtm error', 'NO GTM ID');
    return;
  }
  if (dataLayerPreload) {
    window.dataLayer = window.dataLayer || [];
    if (dataLayerPreload) {
      window.dataLayer.push(dataLayerPreload);
    }
  }
  _loading = true;
  return createGtmScript(
    window,
    document,
    'script',
    'dataLayer',
    gtmId,
    (event: any) => {
      _loading = false;
      const { userId } = dataLayerPreload || {};
      const { dataLayer } = window;
      logger.groupCollapsed('initialized', gtmId);
      logger.log('version', window.__gtmHookVersion);
      logger.log('gtmId', gtmId);
      logger.log('userId', userId);
      logger.log('dataLayer', { dataLayer });
      logger.log('event', { event });
      logger.groupEnd();
    }, // onload
    (event: any) =>
      console.error('[GTM] error', gtmId, {
        version: window.__gtmHookVersion,
        event,
      }), // onerror
  );
}

const initializeGTM = (gtmId: string, userId?: string | null) => {
  _gtmScript = initGtm(gtmId, { userId });
};

const isLoading = () => _loading;
const isInitialized = () => !isLoading() && _loading !== null;

export const useGtm = () => ({
  initializeGTM,
  isInitialized,
  isLoading,
  _gtmScript,
});
